import React from 'react';
import './KeepMyAssetLogo.css';

const KeepMyAssetLogo = () => (
  <div className="keepmyasset-logo" aria-label="KeepMyAsset home">
    <img
      className="keepmyasset-logo__image"
      src="/KeepMyAssetLogo.jpg"
      alt=""
      loading="lazy"
      decoding="async"
    />
    <span className="keepmyasset-logo__text">
      KeepMy<span className="keepmyasset-logo__accent">Asset</span>
    </span>
  </div>
);

export default KeepMyAssetLogo;
